import axios from "axios";
const apiClient = axios.create({
  // baseURL: 'https://api.fantasylineups.com/',
  baseURL: "https://api.fantasylineups.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  getAllTeams() {
    return apiClient.post("nhl/getAllteams");
  },

  getDepthChart(params) {
    return apiClient.post("nhl/getdepthchart", params);
  },

  getUpcomingGames(params) {
    return apiClient.post("nhl/getupcomingmatch", params);
  },

  getInjuries(params) {
    return apiClient.post("nhl/getinjuries", params);
  },

  async getAllSlate(token) {
    return await apiClient.get(`nhl/getAllSlat/${token}`);
  },

  getPlayersDetails(params) {
    return apiClient.post("nhl/getPlayers", params);
  },

  getTeamStack(params) {
    return apiClient.post("nhl/getTeamsBySlatID", params);
  },

  getTeamBuild(params) {
    return apiClient.post("nhl/createbuild/", params);
  },

  getPlayerSwap(params) {
    return apiClient.post("nhl/getswapplayers", params);
  },

  savedLineup(buildTeam) {
    return apiClient.post("user/saveLineup", buildTeam);
  },

  playerPerTeam(TeamsDetails) {
    return apiClient.post("user/playerPerTeam", TeamsDetails);
  },
  resetPlayers(params) {
    return apiClient.post("/user/resetSlat", params);
  },
  unlockPlayer(params) {
    return apiClient.post("user/unlockPlayer", params);
  },
  setTopPlays(params) {
    return apiClient.post("user/setTopPlays", params);
  },

  getTopPlays(params) {
    return apiClient.post("user/getTopplays", params);
  },

  getPremiumFilters(params) {
    return apiClient.post("user/getSlatClients", params);
  },

  getTopPlayers(params) {
    return apiClient.post("nhl/getTopPlayers", params);
  },

  getPlayerTrend(params) {
    return apiClient.post("user/getPlayerTrends", params);
  },

  // player details...
  getFullStat(params) {
    return apiClient.post("nhl/playerDetails", params);
  },

  getPlayerScoring(params) {
    return apiClient.post("user/getPlayerScore", params);
  },
  // player details...

  teamDetails(params) {
    return apiClient.post("nhl/teamProfile", params);
  },

  updateLineup(params) {
    return apiClient.post("user/updateLineup", params);
  },

  getGoalies() {
    return apiClient.post("nhl/getGolies");
  },

  getLineCombination() {
    return apiClient.get("nhl/getlineteams");
  },

  getNhlProps() {
    return apiClient.get("nhl/nhl_props");
  },

  getNhlNews() {
    return apiClient.get("nhl/nhl_news");
  },
};
